export default __webpack_public_path__ + "static/Cover-e6ee47fbd354d165b3f98b2e0f060b4f.png";